import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RichmenuMaintenance from 'pages/toyotaMaintenance/RichmenuMaintenance';
import ShowRoomMaintenance from 'pages/toyota/ShowRoomMaintenance';
import MemberTagSearch from 'pages/toyotaMaintenance/MemberTagSearch';
import BroadcastMaintenance from 'pages/toyotaMaintenance/BroadcastMaintenance';
import BroadcastReview from 'pages/toyotaMaintenance/BroadcastReview';

const ToyotaMaintenanceRouter = () => {
    return (
        <Routes>
            <Route path="/RichmenuMaintenance" element={<RichmenuMaintenance />} />
            <Route path="/ShowRoomMaintenance" element={<ShowRoomMaintenance />} />
            <Route path="/MemberTagSearch" element={<MemberTagSearch />} />
            <Route path="/BroadcastMaintenance" element={<BroadcastMaintenance />} />
            <Route path="/BroadcastReview" element={<BroadcastReview />} />
        </Routes>
    );
};

export default ToyotaMaintenanceRouter;